import axios from 'axios';
import axiosRetry from 'axios-retry';
import { getInstance } from '@/auth/authWrapper';

export const API = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_URL,
});
axiosRetry(API, { retries: 3 });

API.interceptors.request.use(
    async (config) => {
        const authService = getInstance();
        if (authService && authService.isAuthenticated) {
            try {
                const token = await authService.getTokenSilently();
                if (token) config.headers.Authorization = `Bearer ${token}`;
            } catch (e) {
                console.error('getTokenSilently failed', e);
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);